import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

enum Tabs {
  FISH_GROUPS = 'fishgroups',
  VIRTUAL = 'virtual',
  HARVESTED = 'harvested',
  PROFILES = 'profiles',
  CALCULATOR = 'calculator',
}

const FishGroupSubTabs: React.FC<Props> = () => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'planningPrognosis.viewSite';
  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.planningPrognosisTabs.fishGroups` }),
          value: Tabs.FISH_GROUPS,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.planningPrognosisTabs.virtual` }),
          value: Tabs.VIRTUAL,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.planningPrognosisTabs.harvest` }),
          value: Tabs.HARVESTED,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.planningPrognosisTabs.calculator` }),
          value: Tabs.CALCULATOR,
        },
        {
          label: intl.formatMessage({ id: `${PAGE_NAME_ID}.planningPrognosisTabs.changeProfiles` }),
          value: Tabs.PROFILES,
        },
      ]}
    />
  );
};

export default React.memo(FishGroupSubTabs);
